// extracted by mini-css-extract-plugin
export default {"dialogRoot":"SnackBar_dialogRoot__0ON+a","isEmbed":"SnackBar_isEmbed__YIEvW","container":"SnackBar_container__2AO-9","dialogContent":"SnackBar_dialogContent__DeIeK"};